export default "__VITE_ASSET__2197a920__"